import React from 'react';
// ANTD
import notification from 'antd/lib/notification';
import 'antd/lib/notification/style/css';
// COMPONENTS
import Row from 'components/common/Row';
import Col from 'components/common/Col';
import Button from 'components/common/Button';
import CreateContractModal from 'components/common/CreateContractModal';
import SendQuestionnaireModal from 'components/common/SendQuestionnaireModal';
import SessionFormModal from 'components/common/SessionFormModal';
// APOLLO
import { graphql, compose } from 'react-apollo';
import invoicesByClientIdQuery from 'ApolloClient/Queries/invoicesByClientId';
import invoicesQuery from 'ApolloClient/Queries/invoices';
import createInvoice from 'ApolloClient/Mutations/createInvoice';

// CONSTANTS & DESTRUCTURING
// ===================================

const BUTTON_WIDTH = 180;

const s = {
  button: {
    width: BUTTON_WIDTH,
    maxWidth: '100%',
    marginTop: 8,
    textTransform: 'uppercase',
  },
  column: {
    textAlign: 'center',
  },
  row: {
    minHeight: 90,
    marginBottom: 5,
  },
};

const rowProps = {
  gutter: 15,
  style: s.row,
};

const columnProps = {
  xs: 12,
  sm: 6,
  style: s.column,
};

const buttonProps = {
  style: s.button,
  type: 'primary',
};

class ClientActionsRow extends React.PureComponent {
  onNewContract = () => {
    const { currentUser } = this.props;
    // check if the user has stripe yet, otherwise they can not send an invoice.
    if (!currentUser.organization || !currentUser.organization.stripeUserIdExists) {
      return this.needStripeSignup();
    }
    let clientId = {
      value: this.props.clientId,
    };
    this.props.onContractFlowChange({ clientId });
    this.props.history.push('/contract/create/1');
  };

  needStripeSignup = () => {
    const { history } = this.props;

    const key = `open${Date.now()}`;
    return notification.info({
      message: 'Connect a Payment Service First!',
      description: 'You must connect your Stripe or PayPal account to start creating invoices!',
      key,
      btn: (
        <Button
          onClick={() => {
            history.push('/app/studio');
            notification.close(key);
          }}
        >
          Go To My Studio
        </Button>
      ),
    });
  };

  checkStripe = () => {
    const { currentUser } = this.props;
    return currentUser && currentUser.organization && currentUser.organization.stripeUserIdExists;
  };

  onNewInvoice = () => {
    const { clientId, history, currentUser } = this.props;
    // check if the user has stripe yet, otherwise they can not send an invoice.
    if (!currentUser.paypalSet && !currentUser.stripeSet) {
      return this.needStripeSignup();
    }

    let variables = { params: { clientId } };
    const refetchQueries = [
      {
        query: invoicesByClientIdQuery,
        variables: { _id: clientId },
      },
      {
        query: invoicesQuery,
        variables: { _id: clientId },
      },
    ];

    this.props
      .createInvoice({ variables, refetchQueries })
      .then(({ data }) => {
        history.push(`/invoice/create/1/${data.createInvoice._id}`);
      })
      .catch(err => console.log(err));
  };
  render() {
    const { currentUser } = this.props;

    return (
      <Row {...rowProps}>
        <Col {...columnProps}>
          <CreateContractModal
            triggerType="button"
            clientId={this.props.clientId}
            buttonProps={buttonProps}
            {...this.props}
          />
        </Col>
        <Col {...columnProps}>
          <Button {...buttonProps} onClick={this.onNewInvoice}>
            NEW INVOICE
          </Button>
        </Col>
        <Col {...columnProps}>
          <SessionFormModal
            triggerType="button"
            clientId={this.props.clientId}
            sessionTypes={currentUser.organization && currentUser.organization.sessionTypes}
            buttonProps={buttonProps}
            {...this.props}
          />
        </Col>
        <Col {...columnProps}>
          <SendQuestionnaireModal
            triggerType="button"
            clientId={this.props.clientId}
            email={this.props.client.email}
            buttonProps={buttonProps}
            {...this.props}
          />
        </Col>
      </Row>
    );
  }
}

export default compose(graphql(createInvoice, { name: 'createInvoice' }))(ClientActionsRow);



// WEBPACK FOOTER //
// ./src/routes/app-client-detail/ClientActionsRow/index.js